import { useEffect, useState } from 'react';
import { useToast } from '../hooks/useToast';
import { cn } from '../lib/utils';

function Toast() {
  const { toast } = useToast();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (toast) {
      // Small delay to trigger fade-in animation
      setTimeout(() => setIsVisible(true), 10);

      // Start fade-out 300ms before toast disappears
      const fadeOutTimer = setTimeout(() => {
        setIsVisible(false);
      }, 2700);

      return () => clearTimeout(fadeOutTimer);
    } else {
      setIsVisible(false);
    }
  }, [toast]);

  if (!toast) return null;

  return (
    <div
      className={cn(
        "fixed bottom-6 left-1/2 -translate-x-1/2 z-50 px-4 py-3 rounded-lg bg-foreground text-background shadow-lg transition-all duration-300",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
      )}
    >
      <div className="text-sm font-medium">{toast.message}</div>
    </div>
  );
}

export default Toast;
